import dayjs from "dayjs";
import { roundDecimalValueUptoTwo } from "./roundDecimalValue";

const resolveOpenDate = (openDate) => {
	if (!openDate) return null;
	if (typeof openDate === "object" && openDate.value != null) return openDate.value;
	return openDate;
};

export const calculateStoreAge = (openDate) => {
	const resolved = resolveOpenDate(openDate);
	if (!resolved) return 0;

	const startdate = dayjs(resolved);
	if (!startdate.isValid()) return 0;

	const currentDate = dayjs();
	return roundDecimalValueUptoTwo(Math.abs(startdate.diff(currentDate, "M") / 12));
};
